import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  copiedToClipboard: {
    defaultMessage: 'Copied to Clipboard',
    description: 'Message to display when the text has been copied to the clipboard',
    id: 'kQyjKC',
  },
});
